
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { Product } from '../../components/Product';
import { ProductForm } from '../../components/ProductForm';
import Modal from '../../components/Modal';
import useModal from '../../helpers/useModal';
import { Loader } from '../../helpers/loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faArchive, faCheck } from '@fortawesome/free-solid-svg-icons'
import { supabase } from '../../api'
import ELNStore from "../../store";
import { DebounceInput } from "react-debounce-input";
import CategoryForm from "../../components/CategoryForm";

export const Categories = () => {

  const currentUser = ELNStore.useState(s => s.currentUser);

  const { showModal, toggleModal } = useModal()
  const [ canDelete, setCanDelete ] = useState(false)
  
  const [ category, setCategory ] = useState()
  const [products, setProducts] = useState()
  
  const [categories, setCategories] = useState()
  

  useEffect ( () => {
    async function fetchData() {

     const { data: products, error: productsErr } = await supabase
        .from('products')
        .select('*, categories (*), suppliers (*), shopProducts(*)')
         
      const { data: categories, error: categoriesErr } = await supabase
        .from('categories')
        .select('*')
        .order('position')
      
      setCategories(categories)
      setProducts(products)
    }
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])



  const newCategory = () => {
    setCanDelete(false)
    setCategory(undefined)
    toggleModal()
  }


  const handleSave = (category) => {
    const newCategories = [...categories.filter(c => c.id !== category.id), category].sort((a,b) => a.position > b.position ? 1: -1)
    setCategories(newCategories)
    toggleModal()
  }


  const handleDelete = (id) => {
    const newCategories = [...categories.filter(c => c.id !== id)].sort((a,b) => a.position > b.position ? 1: -1)
    setCategories(newCategories)
    toggleModal()
  }

  if (!categories || !products) return <Loader />
  
  
  return (
    <div className='outer'>
        <h1>Categories</h1>

        <ul className='button-list'>
          {currentUser.p_admin>=2 && <li><button  className='clear' onClick={newCategory}><FontAwesomeIcon icon={faPlus} />&nbsp;ADD NEW CATEGORY</button></li>}

        </ul>
        <Modal
          isShowing={showModal}
          title={category ? 'Edit Category' : 'Add New Category'}
          hide={toggleModal}
        >

          <CategoryForm handleSave={handleSave} canDelete={canDelete} defaultCategory={category} handleDelete={handleDelete} />


        </Modal>

        <div className='table-wrapper'>
        <table>
          <thead className='stickyTop'>

            <tr>
                <th rowspan={2}>NAME</th>
                <th className='center' rowspan={2}>POSITION</th>
                <th rowspan={2}></th>
                <th className='center' colspan={4}>PRODUCTS</th>
                
            </tr>
            <tr>
                <th className='right'>TOTAL</th>
                <th className='right'>ACTIVE</th>
                <th className='right'>ARCHIVED</th>
                <th className='right'>AVAILABLE TO BUY</th>
            </tr>

          </thead>
          <tbody>
          {categories.map(category => {
            const totalProductsOfCategory = products.filter(p => p.category_id === category.id)
            const productsActive = totalProductsOfCategory.filter(p => p.active)
            const productsArchived = totalProductsOfCategory.filter(p => !p.active)
            const productsAvailable = totalProductsOfCategory.filter(p => !!p.shopProducts.length)

            const selectCategory = (canDelete) => {
              setCanDelete(canDelete)
              setCategory(category)
              toggleModal()
            }
            const canDelete = totalProductsOfCategory?.length === 0



            return (<tr key={category.id}>
                <td><b>{category.name}</b></td>
                <td className='center'>{category.position}</td>
                <td className='center'><button className='' onClick={()=>selectCategory(canDelete)}>Edit</button></td>
                <td className={`right ${canDelete ? 'can-delete' : ''}`}>{totalProductsOfCategory?.length || 0}</td>
                <td className='right'>{productsActive?.length || 0}</td>
                <td className='right'>{productsArchived?.length || 0}</td>
                <td className='right'>{productsAvailable?.length || 0}</td>
            </tr>)
           })}
          </tbody>
        </table>

        </div>
        
    </div>

  )
}

export default withRouter(Categories);
